import Vue from 'vue'
import vueCountryRegionSelect from 'vue-country-region-select'

// select country/region
Vue.use(vueCountryRegionSelect)
